import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LicenseApiService } from '@wdx/clmi/clmi-swagger-gen/api-services';
import { catchError, map, of, switchMap } from 'rxjs';
import * as licenseActions from './license.actions';

@Injectable()
export class LicenseEffects {
    private actions$ = inject(Actions);
    private licenseApiService = inject(LicenseApiService);

    getLicense$ = createEffect(() =>
        this.actions$.pipe(
            ofType(licenseActions.getLicense),
            switchMap(() =>
                this.licenseApiService.get().pipe(
                    map((license) =>
                        licenseActions.getLicenseSuccess({
                            license,
                        })
                    ),
                    catchError((error) =>
                        of(
                            licenseActions.getLicenseFailure({
                                error,
                            })
                        )
                    )
                )
            )
        )
    );
}
